module.exports = __webpack_public_path__ + "static/web-click-spoofing-57ff4a57793e3283607db1f45217e93a.gif";